var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Button } from '..';
import styled from 'styled-components';
var OuterContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    svg{\n        ", ";\n    }\n"], ["\n    svg{\n        ", ";\n    }\n"])), function (props) { return props.marked && "stroke: #950014"; });
var BookmarkButton = /** @class */ (function (_super) {
    __extends(BookmarkButton, _super);
    function BookmarkButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleButton = _this.handleButton.bind(_this);
        _this.state = {
            marked: _this.props.marked,
        };
        return _this;
    }
    BookmarkButton.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ marked: nextProps.marked });
    };
    BookmarkButton.prototype.render = function () {
        var _a, _b;
        return (React.createElement(OuterContainer, { marked: this.state.marked },
            React.createElement(Button, { onClick: this.handleButton, size: (_a = this.props.size) !== null && _a !== void 0 ? _a : "default", disabled: this.props.disabled, kind: this.props.kind, floated: (_b = this.props.floated) !== null && _b !== void 0 ? _b : undefined, icon: this.state.marked ? "bookmark" : "bookmark outline" })));
    };
    BookmarkButton.prototype.handleButton = function () {
        this.setState({ marked: !this.state.marked });
        this.props.onChange(!this.props.marked);
    };
    return BookmarkButton;
}(React.Component));
export default BookmarkButton;
var templateObject_1;
//# sourceMappingURL=BookmarkButton.js.map